import { Action } from "redux";
import { IPageError, IAppPage, IPageContainerState } from "./page";


export type IPageAction = IFetchPageDataAction
    | IFetchPageDataSuccessAction
    | ISetPageThemeAction
    | ISetPageHasHeroAction
    | ISetPageIsTransitioningAction
    | IFetchPageDataErrorAction;

export enum PageActionTypes {
    FETCH_DATA = "@@page/FETCH_DATA",
    FETCH_DATA_SUCCESS = "@@page/FETCH_DATA_SUCCESS",
    FETCH_DATA_ERROR = "@@page/FETCH_DATA_ERROR",
    SET_THEME = "@@page/SET_THEME",
    SET_HERO = "@@page/SET_HERO",
    SET_TRANSITIONING = "@@page/SET_TRANSITIONING",
}

export interface IFetchPageDataAction extends Action<PageActionTypes.FETCH_DATA> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
}

export const fetchPageData = (): { type: PageActionTypes } => ({
    type: PageActionTypes.FETCH_DATA,
});

export interface IFetchPageDataSuccessAction extends Action<PageActionTypes.FETCH_DATA_SUCCESS> {
    payload: IAppPage;
}

export const fetchPageDataSuccess = (pageData: IPageContainerState): IFetchPageDataSuccessAction => ({
    type: PageActionTypes.FETCH_DATA_SUCCESS,
    payload: pageData,
});

export interface IFetchPageDataErrorAction extends Action<PageActionTypes.FETCH_DATA_ERROR> {
    error: IPageError;
}

export const fetchPageDataError = (error: IPageError): IFetchPageDataErrorAction => ({
    type: PageActionTypes.FETCH_DATA_ERROR,
    error,
});

export interface ISetPageThemeAction extends Action<PageActionTypes.SET_THEME> {
    hexColor?: string;
}

export const setPageTheme = (hexColor?: string): ISetPageThemeAction => ({
    type: PageActionTypes.SET_THEME,
    hexColor,
});

export interface ISetPageHasHeroAction extends Action<PageActionTypes.SET_HERO> {
    hasHero: boolean;
}

export const setPageHasHero = (hasHero: boolean): ISetPageHasHeroAction => ({
    type: PageActionTypes.SET_HERO,
    hasHero,
});

export interface ISetPageIsTransitioningAction extends Action<PageActionTypes.SET_TRANSITIONING> {
    isTransitioning: boolean;
}

export const setPageIsTransitioning = (isTransitioning: boolean): ISetPageIsTransitioningAction => ({
    type: PageActionTypes.SET_TRANSITIONING,
    isTransitioning,
});
